import { format } from 'url';
import type { Href } from './types';

export function urlObjectToString(href: Href): string {
  return typeof href === 'string' ? href : format(href);
}
